/**
 * Provided a value and a ValueType, returns the value as that value type.
 */var getValueAsType=function getValueAsType(value,type){return type&&typeof value==="number"?type.transform(value):value;};export{getValueAsType};